import React from 'react'
import { $neutralGray10 } from '../../styles/colors/primitives'

function AddIcon({ color }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_3879_1054)">
        <path d="M10.625 9.375V5H9.375V9.375H5V10.625H9.375V15H10.625V10.625H15V9.375H10.625Z" fill={color || $neutralGray10}/>
      </g>
      <defs>
        <clipPath id="clip0_3879_1054">
          <rect width="20" height="20" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default AddIcon
